import React from 'react';

// MuzzleBody — Fixed construction — 主体 shading (gradient id6), highlights, straps, seams (no drawer menu item)
// MUZZLE mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.

export function MuzzleBody({ parts, polygons }) {
  return (
    <>
<path fill="url(#id6)" d={parts['fill-url_id6_-path-7'] || ''}/>
<g id="_2100842923040">
<polygon className="fil-FEFEFE" points={polygons['polygon-1'] || ''}/>
<polygon className="fil-FEFEFE" points={polygons['polygon-2'] || ''}/>
<path className="fil-FEFEFE" d={parts['fill-FEFEFE-path-8'] || ''}/>
<path className="fil-FEFEFE" d={parts['fill-FEFEFE-path-9'] || ''}/>
<path className="fil-FEFEFE" d={parts['fill-FEFEFE-path-10'] || ''}/>
</g>
<path className="clear str_222222_75" d={parts['clear-path-11'] || ''}/>
<g id="_2102246509696">
<path className={"hood-black str_222222_75"} d={parts['path-12'] || ''}/>
<g>
	<path className={"hood-black str_222222_75"} d={parts['path-13'] || ''}/>
	<path className="clear str_222222_75" d={parts['clear-path-14'] || ''}/>
	<path className="clear str_222222_35_70_35" d={parts['clear-path-15'] || ''}/>
	<path className="clear str_222222_35_70_35" d={parts['clear-path-16'] || ''}/>
</g>
</g>
    </>
  );
}
